import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import store from './store/index'
import IdleVue from 'idle-vue'
//import XLSX from 'xlsx'
const eventsHub = new Vue();
// 1 hora = 3600000 
Vue.use(IdleVue, {eventEmitter:eventsHub, idleTime: 10000});
Vue.config.productionTip = false
Vue.filter("currency", (value) => new Intl.NumberFormat("en-US", { style: "currency", currency: "MXN" }).format(value));
//Vue.use(XLSX)

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
